import { reactive } from 'vue'
import { api } from './api'

export const authState = reactive<{ authenticated: boolean | null }>({ authenticated: null })

export async function checkAuth(): Promise<boolean> {
  try {
    const result = await api.me()
    authState.authenticated = result.authenticated
  } catch {
    authState.authenticated = false
  }
  return authState.authenticated === true
}

export async function login(password: string): Promise<boolean> {
  try {
    await api.login(password)
    authState.authenticated = true
    return true
  } catch {
    authState.authenticated = false
    return false
  }
}

export async function logout(): Promise<void> {
  try {
    await api.logout()
  } finally {
    authState.authenticated = false
  }
}
